import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hpbs/frontend/components/containers/Projects/components/StepCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hpbs/frontend/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/node_modules/next/dist/client/image-component.js");
